export default __webpack_public_path__ + "static/united-states-3b5a3c1c94cf595614fd472718f69a37.svg";